import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import RctModel from "../../../../core/BaseComponents/RctModal";
import { Grid } from "@mui/material";
import { callAPI } from "../../../../../axios";
import Controls from "../../../../core/Controls/Controls";
import { FormControl, ListItem, MenuItem, Select } from "@mui/material";
import { useForm, Form } from "../../../../core/Controls/useForm";
import "./AddPermission.scss";
import CloseIcon from "@mui/icons-material/Close";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const AddPermission = (props) => {
  let txt = props.edit ? "EDIT PERMISSION" : "ADD PERMISSION";
  let btnTxt = props.edit ? "Update" : "Add";
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: "15rem",
        // width: 250,
      },
    },
  };

  const [loading, setLoading] = useState(false);
  const { item } = props;
  const [moduleList, setModuleList] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState([]);
  const [searchModuleList, setSearchModuleList] = useState([]);
  const initialValue = {
    module: props.selectedModule,
    selectedPermission: item ? item.selectedPermission : [],
  };
  const findError = (data) => {
    let flag = false;
    if (data.some((x) => x.checked == true)) {
      flag = true;
    }
    return flag;
  };
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("module" in fieldValues) {
      temp.module = fieldValues.module ? "" : "Module required";
    }
    if ("selectedPermission" in fieldValues) {
      temp.selectedPermission = findError(fieldValues.selectedPermission)
        ? ""
        : "Please choose atleast one permission";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === "");
    }
  };

  const { values, setValues, errors, setErrors, handleInputChanges } = useForm(
    initialValue,
    true,
    validate
  );

  const formSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      props.onClickHandler(values);
      props.closeHandler(false);
    }
  };

  const populateModuleList = () => {
    if (props.permissions !== undefined && props.permissions.length > 0) {
      const tempModuleList = props.permissions.map((mod) => {
        return {
          ...mod,
          title: mod.permission,
        };
      });
      setModuleList(tempModuleList);
    }
  };

  const populateModuleWisePermissionData = (data) => {
    if (data !== undefined && data.length > 0) {
      const tempModulePermissionList = data.map((per) => {
        return {
          ...per,
          title: per.permission,
        };
      });
      if (Object.keys(props.selectedPermissions).length > 0) {
        if (props.selectedPermissions[values.module]) {
          if (props.userInfo) {
            const savedPermissions = props.userInfo.tempPermissions;
            tempModulePermissionList.forEach((ele) => {
              if (savedPermissions[values.module]) {
                const itemIndex = savedPermissions[
                  values.module
                ].selectedPermission.findIndex((sp) => sp.id === ele.id);
                ele.checked = false;
                if (itemIndex > -1) {
                  if (
                    savedPermissions[values.module].selectedPermission[
                      itemIndex
                    ].checked
                  ) {
                    ele.checked = true;
                  }
                }
              }
            });
          }
        }
      }
      setValues({
        ...values,
        selectedPermission: tempModulePermissionList,
      });
      setSearchModuleList({
        ...values,
        selectedPermission: tempModulePermissionList,
      });
    }
  };

  const getModulePermissions = () => {
    setLoading(true);
    const apiPath = `master/permission?loadChildPermission=true&parentPermissionSid=${values.module}`;
    // api
    //   .get(apiPath)
    callAPI(apiPath, "GET")
      .then((res) => {
        populateModuleWisePermissionData(res);
      })
      .catch((err) => {
        console.warn(err.message);
      })
      .finally((_) => {
        setLoading(false);
      });
  };

  const updateSelectedPermissionList = (args, item) => {
    const currentValue = args.target.value;
    const temp = values.selectedPermission;
    temp.forEach((t) => {
      if (t.id === item.id) {
        t.checked = currentValue;
      }
    });
    setValues((prev) => ({
      ...prev,
      selectedPermission: temp,
    }));
    setSearchModuleList((prev) => ({
      ...prev,
      selectedPermission: prev.selectedPermission.map((prevItem) =>
        temp.some((tempItem) => item.id === prevItem.id)
          ? { ...prevItem, checked: currentValue }
          : prevItem
      ),
    }));
    setErrors({
      ...errors,
      selectedPermission: "",
    });
  };

  useEffect(() => {
    const temp = values.selectedPermission;
    let count = 0;
    temp.forEach((t) => {
      if (t.checked === true) {
        count = count + 1;
        if (count === values.selectedPermission.length) {
          setSelectAllChecked(true);
        } else {
          setSelectAllChecked(false);
        }
      }
      if (t.checked === false) {
        setSelectAllChecked(false);
      }
    });
  }, [values]);

  const selectAllPermissionList = (e) => {
    let temp = values.selectedPermission;
    if (e.target.value === false) {
      setSelectAllChecked(false);
      temp.forEach((t) => {
        t.checked = false;
      });
      setValues({
        ...values,
        selectedPermission: temp,
      });
      setSearchModuleList({
        ...values,
        selectedPermission: temp,
      });
      setErrors({
        ...errors,
        selectedPermission: "",
      });
    } else {
      setSelectAllChecked(true);
      temp.forEach((t) => {
        t.checked = true;
      });
      setValues({
        ...values,
        selectedPermission: temp,
      });
      setSearchModuleList({
        ...values,
        selectedPermission: temp,
      });
      setErrors({
        ...errors,
        selectedPermission: "",
      });
    }
  };

  useEffect(() => {
    if (values.module) {
      props.setSelectedModule(values.module);
      if (values.module !== 0) {
        getModulePermissions();
      }
    }
  }, [values.module]);

  useEffect(() => {
    const permissionSids = [];
    Object.keys(values.selectedPermission).forEach((moduleId) => {
      if (props.selectedPermissions[moduleId]) {
        props.selectedPermissions[moduleId].selectedPermission.forEach(
          (per) => {
            if (per.checked) {
              permissionSids.push(per.id);
            }
          }
        );
      }
    });
    props.setUserInfo({
      ...props.userInfo,
      permissions: values.selectedPermission,
    });
  }, [values.selectedPermission]);

  useEffect(() => {
    props.permissions.length > 0 && populateModuleList();
  }, [props.permissions]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    let initialCustomizeData = JSON.parse(
      JSON.stringify(searchModuleList?.selectedPermission)
    );
    const tempSearch = initialCustomizeData?.filter((selectedPermissionList) =>
      selectedPermissionList.permission
        .toLowerCase()
        .includes(e.target.value.toLowerCase())
    );
    setValues({
      ...values,
      selectedPermission: tempSearch,
    });
  };
  useEffect(() => {
    if (props.edit) {
      setInputValue(
        moduleList?.filter((make) => make.id === values.module)[0]?.permission
      );
    }
  }, [props.edit, inputValue]);
  return (
    <RctModel
      isOpen={props.open}
      contentLabel={txt}
      className="rec-model"
    //   ClassName="delete-fault add-permission add-permission-model"
    >
      {/* <Loader show={loading} /> */}
      <div className="mt-0 p-3">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className="d-flex justify-content-between ml-2">
              <strong>{txt}</strong>
              <span
                className="cursor-pointer"
                onClick={() => props.closeHandler(false)}
              >
                <CloseIcon />
              </span>
            </div>
          </Grid>
          <Grid item xs={12} className="grid-block">
            <Form>
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                style={{ flexDirection: "row" }}
              >
                <Grid item xs={12}>
                  <ListItem
                    style={{
                      display: "block",
                      padding: "0px",
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        name={"module"}
                        className="w-100"
                        value={value}
                        onChange={(event, newValue) => {
                          handleInputChanges({
                            name: "module",
                            value: moduleList?.filter(
                              (make) => make?.permission === newValue
                            )[0].id,
                          });
                          setValue(newValue);
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="controllable-states-demo"
                        options={moduleList?.map((make) => make?.permission)}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                      <p style={{ color: "red", fontWeight: "normal" }}>
                        {errors.selectedPermission}
                      </p>
                    </FormControl>
                  </ListItem>
                </Grid>
                <Grid item xs={12}>
                  {values?.module ? (
                    <div className="role-checklist">
                      <div className="top-right-filter">
                        <Controls.Checkbox
                          className="selectAdd"
                          name="selectAll"
                          label="Select All"
                          checked={selectAllChecked ? true : false}
                          onChange={selectAllPermissionList}
                        />
                        <form
                          onsubmit="event.preventDefault();"
                        >
                          <div className="search-input">
                            <FontAwesomeIcon
                              icon={faSearch}
                            />
                            <input
                              type="text"
                              name="input-search"
                              className="form-control"
                              placeholder="Search here..."
                              onChange={handleSearch}
                              value={searchText}
                              onKeyPress={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="role-checklist-border">
                        <ul>
                          <div className="role-checklist-list-style">
                            {values?.selectedPermission.length > 0 ? (
                              <li>
                                {values.selectedPermission.map((item) => {
                                  return (
                                    <Controls.Checkbox
                                      key={item.id}
                                      name={item.title}
                                      label={item.title}
                                      checked={item.checked ? true : false}
                                      onChange={(args) =>
                                        updateSelectedPermissionList(args, item)
                                      }
                                    />
                                  );
                                })}
                              </li>
                            ) : (
                              <li className="p-3">Search Not Found</li>
                            )}
                          </div>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                {values?.selectedPermission != "" && (
                  <Grid item xs={12}>
                    <div className="flex-items-end mt-2">
                      <button
                        type="button"
                        className="cancel-btn_new me-3"
                        onClick={(e) => {
                          e.preventDefault();
                          getModulePermissions();
                        }}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="create-btn"
                        onClick={formSubmit}
                      >
                        {btnTxt}
                      </button>
                    </div>
                  </Grid>
                )}
              </Grid>
            </Form>
          </Grid>
        </Grid>
      </div>
    </RctModel>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.permissionReducer.permissions,
  };
};

const mapDispatcherToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatcherToProps)(AddPermission);
